import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Context
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';

// Pages
import HomePage from './pages/HomePage';
import MilyemPage from './pages/MilyemPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import Uyum from './pages/Uyum';
import BilgiToplumHizmetleri from './pages/BilgiToplumHizmetleri';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Scroll performansı optimizasyonları
    const optimizeScroll = () => {
      // Smooth scrolling için CSS scroll-behavior kullanılıyor
      // GPU hızlandırma için transform3d kullanılıyor
      
      // Scroll event listener'ları optimize et
      let ticking = false;
      
      const handleScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            // Scroll işlemleri burada yapılabilir
            ticking = false;
          });
          ticking = true;
        }
      };
      
      window.addEventListener('scroll', handleScroll, { passive: true });
      
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    };
    
    optimizeScroll();
  }, []);

  return (
    <LanguageProvider>
      <ThemeProvider>
        <Router>
          <div className="App">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/milyem" element={<MilyemPage />} />
                <Route path="/hakkimizda" element={<AboutPage />} />
                <Route path="/uyum" element={<Uyum />} />
                <Route path="/bilgi-toplum-hizmetleri" element={<BilgiToplumHizmetleri />} />
                <Route path="/iletisim" element={<ContactPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
